import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

import { default as optMap } from 'src/assets/mapOptions/themeGray';
import { default as listIndicatives } from 'src/app/utils/listIndicatives';

@Injectable({
  providedIn: 'root'
})
export class SharedService {


  static optMap = optMap;
  static listIndicatives = listIndicatives;

  // Objetos Observable y Emiters
  private showLoader$ = new Subject<boolean>();

  constructor() { }

  emmiterShowLoader( value: boolean ): void {
    this.showLoader$.next(value);
  }

  getSubjetShowLoader(): Subject<boolean> {
    return this.showLoader$;
  }

  getoptionsMap(): any {
    return SharedService.optMap;
  }

  getListIndicatives(): any {
    return SharedService.listIndicatives;
  }

  validateOnlyNumbers(val: string) {
    var re = /^([0-9])*$/;
    return re.test(val);
  }

  validateEmail(email: string) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validSession(): boolean {
    let flag = 0;
    if(localStorage.getItem('uid')     == null || localStorage.getItem('uid')     == undefined) flag++;
    if(localStorage.getItem('token')   == null || localStorage.getItem('token')   == undefined) flag++;
    if(localStorage.getItem('session') == null || localStorage.getItem('session') == undefined) flag++;
    if(flag > 0) return false;
    return true;
  }

  saveUserStorage(user: any) {
    localStorage.setItem('user', JSON.stringify(user) )
  }

  searchOnList(array: any, by: any, terms: any) {
    let result = array.filter((item: any )=> item[by].toLowerCase().indexOf(terms.toLowerCase()) > -1);
    return result;
  }

  removeItemFromArr( arr, item ){
    let i = arr.indexOf( item );
    i !== -1 && arr.splice( i, 1 );
  }

  formatCurrency(item: any) {
    return Intl.NumberFormat('es-CO',{
      style: 'currency',
      currency: 'COP',
      minimumFractionDigits: 0
    }).format( parseInt(item) ) ;
  }

  closeSession(): void {
    localStorage.removeItem('token')
    localStorage.removeItem('uid')
    localStorage.removeItem('session')
    localStorage.removeItem('longitude')
    localStorage.removeItem('latitude')
    localStorage.removeItem('user_ip')
    localStorage.removeItem('user_phone')
    localStorage.removeItem('place_id')
    localStorage.removeItem('client_categories')
    localStorage.removeItem('search_delivery_in_store_timestamp')
    localStorage.removeItem('modality')
    localStorage.removeItem('user_address')
  }

  getCoverImage(): string {
    let companuId = localStorage.getItem('companyId');
    switch (companuId) {
      case 'BW':
        return '/assets/imgs/location/BW.png';
      case '917':
        return '/assets/imgs/location/BW.png';
      case 'FUKU':
        return '/assets/imgs/location/FUKU.png';
      case '936': // produccion
        return '/assets/imgs/location/FUKU.png';
      case '940': // pruebas
        return '/assets/imgs/location/FUKU.png';
      case 'DOSCH':
        return '/assets/imgs/location/DCH.png';
      case '918':
        return '/assets/imgs/location/DCH.png';
      default:
        return '/assets/imgs/choose-store/cover-desktop.jpg'
    }

  }

}
